export const config = {
  apiBaseUrl: {
    // development: ((globalThis as any).process?.env?.['API_BASE_URL'] as string | undefined) || 'http://localhost:4004/api',
    //  development: "http://localhost:8084/api",
    development: 'https://dev.api.collegerecon.com/api',
    staging: 'https://stage.api.collegerecon.com/api',
    production: 'https://api.collegerecon.com/api',
  },
  serverUrl: {
    development: 'https://dev.app.collegerecon.com',
    staging: 'https://stage.app.collegerecon.com',
    production: 'https://app.collegerecon.com',
  },
  flowUrl: {
    development: 'https://dev.search.collegerecon.com',
    staging: 'https://stage.search.collegerecon.com',
    production: 'https://search.collegerecon.com',
  },
  careerreconUrl: {
    development: 'https://dev.app.careerrecon.com',
    staging: 'https://stage.app.careerrecon.com',
    production: 'https://app.careerrecon.com',
  },
  resourceUrl: {
    development: 'https://dev.api.collegerecon.com',
    staging: 'https://stage.api.collegerecon.com',
    production: 'https://api.collegerecon.com',
  },
  careerreconApiUrl: {
    development: 'https://dev.api.careerrecon.com/api',
    staging: 'https://stage.api.careerrecon.com/api',
    production: 'https://api.careerrecon.com/api',
  },
  superadminUrl: {
    // development: ((globalThis as any).process?.env?.['API_BASE_URL'] as string | undefined) || 'https://dev.superadmin.collegerecon.com',
    // development: 'http://localhost:3000',
    development: 'https://dev.superadmin.collegerecon.com',
    staging: 'https://stage.superadmin.collegerecon.com',
    production: 'https://cr-admin.collegerecon.com',
  },

  careerReconBucketUrl: {
    development: 'https://s3.amazonaws.com/careerrecon.staging',
    staging: 'https://s3.amazonaws.com/careerrecon.staging',
    production: 'https://s3.amazonaws.com/careerrecon.prod',
  },
};
